import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { sendVisitVitrinEvent } from '@src/helpers/mindbox/mindboxEvents';
import { isProduction } from '@src/utils';
import { checkIsNeededToSendVisitMindboxEvent } from '@src/utils/checkForSendMindboxVisitEvent';
import queue from '@src/utils/queue';

const WEBPUSH_DELAY = 7000;

export const useInitSentryAndMindbox = () => {
  const { asPath } = useRouter();
  const [pathWithoutQuery] = asPath.split('?');

  const isNeededToSendVisitMindboxEvent = checkIsNeededToSendVisitMindboxEvent(pathWithoutQuery);

  useEffect(() => {
    if (!isProduction) {
      return;
    }

    const { publicRuntimeConfig } = getConfig();

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const Sentry = require('@sentry/nextjs');

    queue.push(() => {
      Sentry.init({
        dsn: publicRuntimeConfig.sentryDSN,
        release: publicRuntimeConfig.release,
        tracesSampleRate: 0.05,
        environment: publicRuntimeConfig.environment,
        ignoreErrors: [
          `Failed to execute 'evaluate' on 'Document': The string '' is not a valid XPath expression.`,
          'timeout of 15000ms exceeded',
          'Network Error',
          'Request aborted',
          'Request failed with status code 502',
          'Request failed with status code 400',
          'Request failed with status code 500',
        ],
      });
    });

    queue.push(() => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker
          .register('/service-worker.js')
          .then(() => {
            setTimeout(() => {
              if (typeof window.mindbox === 'undefined') {
                return;
              }

              window.mindbox('webpush.subscribe', {
                onGranted: () => undefined,
                onDenied: () => undefined,
              });
            }, WEBPUSH_DELAY);
            if (isNeededToSendVisitMindboxEvent) {
              sendVisitVitrinEvent(pathWithoutQuery);
            }
          })
          .catch((error) => {
            console.error('Error during service worker registration:', error);
          });
      }
    });
  }, [isNeededToSendVisitMindboxEvent, pathWithoutQuery]);
};
